import { Pipe, PipeTransform } from '@angular/core';
import { ProjectModule } from '../../resources/module/project-module.interface';

/**
 * Hides all empty modules, submodules and elements.
 */
@Pipe({
  name: 'pveFilter'
})
export class PveFilterPipe implements PipeTransform {

  /**
   * Hides all empty modules, submodules and elements.
   *
   * Adds `hide: true` when the submodule or module contains to data, so they won't show up
   * in templates, and it makes sure the chapters are correct and consistent.
   *
   * @param modules The project's modules.
   * @returns Modules with correct properties.
   */
  transform(modules: ProjectModule[]): ProjectModule[] {

    // Check each module.
    for (const module of modules) {
      let hiddenSubmodules = 0;

      // Check the content of each submodule.
      for (const submodule of module.submodules) {

        // Hide when there are no elements.
        if (submodule.elements.length === 0) {
          submodule.hide = true;
          hiddenSubmodules++;

        // Make visible (again) when there are elements.
        } else {
          submodule.hide = false;
          let hiddenElements = 0;
          for (const element of submodule.elements) {
            if (!element.active) {
              hiddenElements++;
            }
          }
          if (submodule.elements.length === hiddenElements) {
            hiddenSubmodules++;
          }
        }
      }

      // Hide the module when empty or when matching one of the above checks. Otherwise, make it
      // visible (again) when the submodule has changed during runtime.
      if (module.submodules.length === 0 || module.submodules.length === hiddenSubmodules || module.isTechnicalType) {
        module.hide = true;
      } else {
        module.hide = false;
      }
    }
    return modules;
  }
}
